import { render, staticRenderFns } from "./list-exchange-requested-btn .vue?vue&type=template&id=55f9882a&"
import script from "./list-exchange-requested-btn .vue?vue&type=script&lang=js&"
export * from "./list-exchange-requested-btn .vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports